<template>
  <div>
    <v-toolbar fixed tabs color="white elevation-0" style="top:65px; position:fixed;">
      <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
      <v-btn icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-btn>
      <v-toolbar-title>{{processedArtist.name}} </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon><v-icon>more_vert</v-icon></v-btn>
      <small>{{processedArtist.last_name}}, {{processedArtist.first_name}}</small>
      
      <v-tabs slot="extension" color="transparent" slider-color="purple"  align-with-title v-model="currentTab">

        <v-tab v-for="tab in this.constants.ARTIST.tabs" :ripple="false"
          :key="tab.key" 
          :href="'#tab-' + tab.key" 
          @click="saveCurrentTab('tab-' + tab.key)"
        >
          {{ tab.title }}
        </v-tab>
      </v-tabs>

    </v-toolbar>

      <v-tabs-items v-model="currentTab" style="">
        <v-tab-item v-for="tab in this.constants.ARTIST.tabs" 
          :key="tab.key" 
          :id="'tab-' + tab.key" >
          
          <v-card flat v-if="!tab.component">
            <v-card-text v-if="tab.fields">
              <!-- <div v-if="processedArtist">
                {{processedArtist.name}}
              </div> -->
              <field-box v-for="field in tab.fields" :artist="processedArtist" :field="field" :key="field.key"></field-box>                
            </v-card-text>
          </v-card>
          
          <v-card flat v-else>
            <component v-bind:is="tab.component" :artist="processedArtist">
              <!-- component changes when vm.currentView changes! -->
            </component>
          </v-card>

        </v-tab-item>
      </v-tabs-items>
      
  </div>
</template>

<script>
  import FieldBox from './FieldBox'
  import axios from '@/utils/apiClient'
  import { mapState } from 'vuex'
  import ViewArtworks from '@/components/artists/ViewArtworks.vue'
  import MultiArtist from '@/components/artists/MultiArtist.vue'

  export default {
    data () {
      return {
        result: '',
        currentTab: this.$store.state.currentTabArtist
        // artwork: '',
        // artist: ''
      }
    },
    props: ['field','artist','artwork'],
    // components: {HeaderArtist},
    beforeMount () {
      // console.log(this.$route.params.artist)
      this.result = this.$route.params.artist
      this.getArtist()
    },
    // updated () {
    //   this.getArtist()
    // },
    // beforeRouteEnter (to, from, next) {
      // getPost(to.params.id, (err, post) => {
        // next(vm => vm.getArtist())
        // console.log('beforeRouteEnter')
      // })
    // },
    methods: {
      saveCurrentTab (tab) {
        this.$store.dispatch("saveCurrentTabArtist", tab)
      },
      getArtist () {
        // console.log('getArtist')
        let url = `${this.$globals.apiserver}/artists/${this.$route.params.id}.json`
        // console.log(url)
        axios.get(url).then((response) => {
          // this.loading = false;
          this.result = response.data
          // this.artwork = response.data
          // this.artist = response.data.artist
          // console.log(this.artist)
          // console.log(this.artwork)
        }).catch((error) => { console.log(error) })
      }
    },
    computed: {
      processedArtist () {
        let processedArtist = this.result
        // this.artwork.map(artwork => {
        //   let a = artwork
        //   artwork.first_name = a ? a.first_name : 'nema meno'
        // })
        // console.log(processedArtist)
        return processedArtist
      },
      // value_calculated (field) {
      //   if (field.table == "artists") {
      //     return eval('this.artwork.artist.'+ field.name)
      //   } else {
      //     return eval('this.artwork.'+ field.name)
      //   }
      // }
      // full_user_fields () {
      //   return this.$store.state.full_user_fields
      // }
    },
    components: {FieldBox,ViewArtworks,MultiArtist}
  }
</script>

<style scoped>
  h1 { font-size: 1em !important; margin-left: 10px; }
  small {font-size:1em; float:left; display: block;}
  /* .toolbar__title {
      margin-left: 20px!important;
      font-weight: 200;
  } */
  .v-tabs-bar {top: 200px;position: fixed;z-index: 1;} 
  .toolbar {margin-top: 0px;top: 80px;position: fixed;z-index: 1;}
  div.tabs__bar.theme--dark.grey {margin-top: 0px;top: 200px;position: fixed;z-index: 1;}
  .tabs__items {margin-top: 120px;}
</style>


// WEBPACK FOOTER //
// src/components/artists/ViewArtist.vue